ALLOWED_CONTROLLER = 'gateways'
ALLOWED_ACTIONS = ['edit']

allOptions = []

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  getOptions()

  $('#gateway_location_id').on 'change', ->
    getOptions()

  $('#gateway_location_ui_node_id').on 'change', ->
    setLatchOptions()

$(document).ready(ready)
$(document).on('turbo:load', ready)


setUiNodeOptions = ->
  selectedOption = ''
  currentLocationId = String($('form.edit_gateway').data('current-location-id'))
  locationId = $('#gateway_location_id').val()
  if currentLocationId == locationId
    selectedOption = ($('form.edit_gateway').data('current-ui-node-id'))
  setOptionsFor($('#gateway_location_ui_node_id'), allOptions, 'unknown (select ui node)', selectedOption)
  setLatchOptions()

setLatchOptions = ->
  selectedOption = ''
  currentUiNodeId = String($('form.edit_gateway').data('current-ui-node-id'))
  uiNodeId = $('#gateway_location_ui_node_id').val()
  if currentUiNodeId == uiNodeId
    selectedOption = ($('form.edit_gateway').data('current-latch-id'))
  latchOptions =
    if uiNodeId == '' || uiNodeId == null
      []
    else
      allOptions.filter((e) ->
        e[0] == parseInt(uiNodeId)
      )[0][2]
  setOptionsFor($('#gateway_location_latch_id'), latchOptions, 'unknown', selectedOption)

setOptionsFor = ($element, options, blankLine = false, selectedValue = '') ->
  $element.empty()
  if options.length == 0
    $element.prop('disabled', true)
    return
  else
    $element.prop('disabled', false)
  if blankLine != false
    $element.append $('<option></option>').attr('value', '').text(blankLine)
  $.each options, (index, option) ->
    $element.append $('<option></option>').attr('value', option[0]).text(option[1])
  if selectedValue != ''
    $element.val(selectedValue)

getOptions = ->
  locationId = $('#gateway_location_id').val()
  if locationId == '' || locationId == null
    allOptions = []
    setUiNodeOptions()
  else
    $.ajax(
      url: "/gateways/" + $('form.edit_gateway').data('gateway-id') + "/get_options.json"
      dataType: 'json'
      data: {
        location_id: $('#gateway_location_id').val()
      }
      success: (data, textStatus, jqXHR) ->
        allOptions = data
        setUiNodeOptions()
      error: (jqXHR, textStatus, errorThrown) ->
        console.log(textStatus)
    )
